/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Trial_BannerInputs */

const en_ad_trial_banner = /** @type {(inputs: Ad_Trial_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trial accounts are limited to videos under 5 minutes. Activate your account to remove this limit.`)
};

const fr_ad_trial_banner = /** @type {(inputs: Ad_Trial_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les comptes d'essai sont limités aux vidéos de moins de 5 minutes. Activez votre compte pour supprimer cette limite.`)
};

const de_ad_trial_banner = /** @type {(inputs: Ad_Trial_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testkonten sind auf Videos unter 5 Minuten beschränkt. Aktivieren Sie Ihr Konto, um diese Beschränkung aufzuheben.`)
};

const it_ad_trial_banner = /** @type {(inputs: Ad_Trial_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gli account di prova sono limitati a video di durata inferiore a 5 minuti. Attiva il tuo account per rimuovere questo limite.`)
};

const ru_ad_trial_banner = /** @type {(inputs: Ad_Trial_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В пробных аккаунтах разрешены видеоролики продолжительностью менее 5 минут. Активируйте свой аккаунт, чтобы снять это ограничение.`)
};

const es_ad_trial_banner = /** @type {(inputs: Ad_Trial_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las cuentas de prueba están limitadas a vídeos de menos de 5 minutos. Activa tu cuenta para eliminar esta limitación.`)
};

const zh_cn2_ad_trial_banner = /** @type {(inputs: Ad_Trial_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`试用账号只能观看时长不超过5分钟的视频。激活账号即可解除此限制。`)
};

const ja_ad_trial_banner = /** @type {(inputs: Ad_Trial_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トライアルアカウントでは、5分未満の動画しかアップロードできません。この制限を解除するには、アカウントを有効化してください。`)
};

const hi_ad_trial_banner = /** @type {(inputs: Ad_Trial_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ट्रायल अकाउंट में 5 मिनट से कम अवधि के वीडियो ही अपलोड किए जा सकते हैं। इस सीमा को हटाने के लिए अपना अकाउंट एक्टिवेट करें।`)
};

const pt_pt2_ad_trial_banner = /** @type {(inputs: Ad_Trial_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As contas de teste são limitadas a vídeos com menos de 5 minutos. Ative sua conta para remover essa limitação.`)
};

/**
* | output |
* | --- |
* | "Trial accounts are limited to videos under 5 minutes. Activate your account to remove this limit." |
*
* @param {Ad_Trial_BannerInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_trial_banner = /** @type {((inputs?: Ad_Trial_BannerInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Trial_BannerInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ad_trial_banner(inputs)
	if (locale === "de") return de_ad_trial_banner(inputs)
	if (locale === "it") return it_ad_trial_banner(inputs)
	if (locale === "ru") return ru_ad_trial_banner(inputs)
	if (locale === "es") return es_ad_trial_banner(inputs)
	if (locale === "zh-CN") return zh_cn2_ad_trial_banner(inputs)
	if (locale === "ja") return ja_ad_trial_banner(inputs)
	if (locale === "hi") return hi_ad_trial_banner(inputs)
	if (locale === "pt-PT") return pt_pt2_ad_trial_banner(inputs)
	return en_ad_trial_banner(inputs)
});